namespace TabAurous.Common {
    export enum AdditionalChargesRateType {
        Fixed = 1,
        Percentage = 2
    }
    Serenity.Decorators.registerEnumType(AdditionalChargesRateType, 'TabAurous.Common.AdditionalChargesRateType', 'Administration.AdditionalChargesRateType');
}
